<template>
    <div class="billing-page">
        <div class="content-heading">
            <i class="ic-head-icon">
                <img src="@/assets/images/sidebar/billing.svg" alt="Rewards Icon">
            </i>
            <h4 class="head-title">Billing</h4>
            <i class="ic-tooltip" id="help"></i>
            <b-popover target="help"
                    triggers="hover"
                    content="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
            </b-popover>
            <app-tab :tabs="tabs"></app-tab>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
import permission from "../../services/user.permission";
const tabs = [
    {
        name: "Account",
        href: "/billing/account",
        access: "billing.account"
    },
    {
        name: "Billing History",
        href: "/billing/history",
        access: "billing.billing-history"
    }
];
export default {
    name: "Billing",
    components: {
        "app-tab": AppTabs
    },
    data() {
        return {
            tabs: tabs,
            permission: permission
        };
    }
};
</script>
